import { Banner } from '@astryxdesign/core/Banner';

interface ValidationErrorsProps {
  errors?: string[] | string;
}

export default function ValidationErrors({ errors }: ValidationErrorsProps) {
  if (!errors || (Array.isArray(errors) && errors.length === 0)) {
    return null;
  }

  const errorList = Array.isArray(errors) ? errors : [errors];

  return (
    <Banner
      status="error"
      title="There was a problem"
      description={
        errorList.length === 1 ? (
          errorList[0]
        ) : (
          <ul>
            {errorList.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        )
      }
      isDismissable
    />
  );
}
